import React, { useEffect, useRef, useState } from 'react';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Badge,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Modal,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from 'reactstrap';
import classnames from 'classnames';
import * as acessos from '../../../acessos.const.util';
import SelectAsyncComponent from '@componentes/select/select-async.component';
import '@common/protocolo/protocolo.styles.css';
import SelectComponent from '@componentes/select/select.component';
import Favoritos from '@componentes/Favoritos';
import IntlMessage from '../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

const ProtocoloPage = (props) => {

	const [selectItems, setSelectItems] = useState([]);
  const intl = useIntl();

  function translate(key) {
    return intl.formatMessage({ id: key });
  }

  const desestruturarProtocolo = (items) => {
    return items.map((item) => ({
      ...item.protocolo,
    }));
  };

	function getStatus(active){
		return <div className={`protocol-status ${active ? 'active' : ''}`} />
	}

	function onSelectItems(e){
		const _selectItems = [...selectItems];
		const index = selectItems.findIndex((x) => x.lamina == e.lamina);
		if(index >-1){
			_selectItems.splice(index, 1);
		}else{
			_selectItems.push(e);
		}

		setSelectItems(_selectItems);
	}

  return (
    props.acessoPermitido(props.usuario, acessos.Microscopia) &&
    props.acessoPermitido(props.usuario, acessos.Adicionar) && (
      <div className="mv-requisicao-protocolo-container">
        <Modal
          centered
          isOpen={props.modalAnticorpoJaLancado.show}
          toggle={props.toggleModalAnticorpoJaLancado}
        >
          <ModalBody>
            <IntlMessage id = "dashboards.examDetail.antibodyInformed"/>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={props.toggleModalAnticorpoJaLancado}
            >
              <IntlMessage id = "dashboards.examDetails.cancel"/>
            </Button>
            <Button
              color="primary"
              onClick={() =>
                props.selecaoProtocolo(props.modalAnticorpoJaLancado.protocolo)
              }
            >
              <IntlMessage id = "dashboards.examDetails.confirm"/>
            </Button>
      
          </ModalFooter>
        </Modal>

        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: props.activeTab === '1' })}
              onClick={() => {
                props.toggle('1');
              }}
            >
              <IntlMessage id = "dashboards.examDetail.adding"/>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ position: 'relative' }}
              className={classnames({ active: props.activeTab === '2' })}
              onClick={() => {
                props.toggle('2');
              }}
            >
              <IntlMessage id = "general.materialArchiving.blades"/>
              <Badge
                className="count-laminas"
                style={{ marginleft: 6, position: 'relative' }}
              >
                {props.reagentesCadastrados.length}
              </Badge>
            </NavLink>
          </NavItem>
					{props.configuracaoVentana && <NavItem>
            <NavLink
              className={classnames({ active: props.activeTab === '3' })}
              onClick={() => {
                props.toggle('3');
              }}
            >
              <IntlMessage id = "protocol.ventana"/>
							<Badge
                className="count-laminas"
                style={{ marginleft: 6, position: 'relative' }}
              >
                {props.ventanaList.length}
              </Badge>
            </NavLink>
          </NavItem>}
        </Nav>
        <br />
        <TabContent activeTab={props.activeTab}>
          <TabPane tabId="1">
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.blocky"/></Label>
                  <SelectComponent
                    value={props.bloco}
                    options={props.listagemBlocos}
                    onChange={(e) => props.selecaoBloco(e)}
                    placeholder={translate("dashboards.examDetail.selectCase")}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.bottle"/></Label>
                  <Input readOnly value={props.frasco} />
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.numberOfExame"/></Label>
                  <Input readOnly value={props.numeroExame || ''} />
                </FormGroup>
              </Col>
              {props.numeroExameExterno && (
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id = "dashboards.examDetails.externalExam"/></Label>
                    <Input readOnly value={props.numeroExameExterno} />
                  </FormGroup>
                </Col>
              )}
              {props.numeroExameAnterior && (
                <Col sm={2}>
                  <FormGroup>
                    <Label><IntlMessage id = "dashboards.examDetails.previousExamNumber"/></Label>
                    <Input readOnly value={props.numeroExameAnterior} />
                  </FormGroup>
                </Col>
              )}
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.Material"/></Label>
                  <Input readOnly value={props.material} />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.doctorRequesting"/></Label>
                  <SelectAsyncComponent
                    disabled={props.bloco === undefined}
                    value={props.medicoselecionado}
                    options={props.medicos}
                    onChange={(e) => props.stateUpdate('medicoselecionado', e)}
                    placeholder={translate("dashboards.examDetail.selectDoctor")}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.typeAntibody"/></Label>
                  <SelectComponent
                    disabled={props.bloco === undefined}
                    value={props.grupo}
                    options={props.listagemGrupoAnticorpos}
                    onChange={(e) => props.selecaoAnticorposPorGrupo(e)}
                    placeholder={translate("dashboards.examDetail.typeSelect")}
                  />
                </FormGroup>
              </Col>
              {props.exameExterno && (
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id = "dashboards.examDetail.destiny"/></Label>
                    <SelectComponent
                      onChange={(e) => {
                        props.atualizarDestino(e);
                      }}
                      options={props.destinos}
                      placeholder={translate("general.materialArchiving.selectDestination")}
                      value={props.selectedDestino}
                      name="destino"
                      disabled={!props.verifyAnticorpos()}
                    />
                  </FormGroup>
                </Col>
              )}
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.antibodies"/></Label>
                  <SelectComponent
                    disabled={
                      props.bloco === undefined ||
                      (props.verifyAnticorpos() &&
                        !props.selectedDestino &&
                        props.exameExterno)
                    }
                    innerRef={props.selectAnticorposRef}
                    options={
                      props.grupo !== undefined
                        ? props.listaAnticorposFiltro.options
                        : props.listagemProtocolos
                    }
                    value={props.anticorpos} //) || ''}
                    onChange={(e) => props.selecaoProtocoloBefore(e)}
                    formatGroupLabel={props.formatGroupLabel}
                    placeholder={translate("dashboards.examDetail.selectReagent")}
                  />
                </FormGroup>
              </Col>
            </Row>

            {props.reagentesSelecionados.length > 0 && (
              <Row>
                <Col sm={'auto'}>
                  {props.reagentesSelecionados.map((reagentes, i) => (
                    <Badge key={i} color="primary" className="badge-reagente">
                      <Badge color="link">{reagentes.protocolo.label}</Badge>
                      <Badge color="dark">{reagentes.protocolo.tipo}</Badge>
                      <span
                        className="remover"
                        onClick={() => props.removerAnticorposLista(i)}
                      >
                        x
                      </span>
                    </Badge>
                  ))}
                </Col>
                <Col></Col>
              </Row>
            )}

            <Favoritos
              className="favoritos"
              tipo="Protocolo"
              itens={props.reagentesSelecionados}
              setFavoritos={props.setFavoritos}
              limparAnticorposSelecionados={props.limparAnticorposSelecionados}
              habilitarSalvarFavoritos={
                props.bloco === undefined ||
                props.reagentesSelecionados.length === 0
              }
            />
            <Button
              className="limpar-campos"
              color="danger"
              size="sm"
              disabled={
                props.bloco === undefined ||
                props.reagentesSelecionados.length === 0
              }
              onClick={props.limparAnticorposSelecionados}
            >
              <IntlMessage id = "dashboards.examDetail.clearFields"/>
            </Button>
            <Button
              color="primary"
              size="sm"
              disabled={
                props.bloco === undefined ||
                props.reagentesSelecionados.length === 0
              }
              onClick={props.adicionarRequisicaoProtocolo}
            >
              <IntlMessage id = "dashboards.examDetail.addAntibodies"/>
            </Button>

          </TabPane>
          <TabPane tabId="2">
            <div className="responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th><IntlMessage id = "general.materialArchiving.requester"/></th>
                    <th><IntlMessage id = "general.materialArchiving.block"/></th>
                    <th><IntlMessage id = "general.materialArchiving.blade"/></th>
                    <th><IntlMessage id = "dashboards.examDetail.antigen"/></th>
                  </tr>
                </thead>
                <tbody>
                  {props.reagentesCadastrados.map((reagentes, i) => {
                    return (
                      <tr key={reagentes.id}>
                        <td>{reagentes.nome}</td>
                        <td>{reagentes.bloco}</td>
                        <td>{reagentes.lamina}</td>
                        <td>
                          <Col>
                            <Badge
                              color="primary"
                              className="badge-reagente"
                              style={{
                                float: 'left',
                              }}
                            >
                              <Badge color="link">{reagentes.anticorpo}</Badge>
                              <Badge color="dark">{reagentes.tipo}</Badge>
                            </Badge>

                            <Button
                              className="editar-cassete"
                              color="link"
                              id={'excluir_' + reagentes.id}
                              onClick={() =>
                                props.removerLaminaLista(reagentes.id, i)
                              }
                            >
                              <i
                                style={{
                                  fontSize: 13,
                                  float: 'right',
                                }}
                                className="fas fa-trash fa-2x"
                              ></i>
                              <UncontrolledTooltip
                                placement="top"
                                target={'excluir_' + reagentes.id}
                              >
                                <IntlMessage id = "dashboards.examDetail.delete"/>
                              </UncontrolledTooltip>
                            </Button>
                          </Col>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </TabPane>
          <TabPane tabId="3">
            <div className="responsive">
              <table className="table ventana-table">
                <thead>
                  <tr>
                    <th><IntlMessage id = "protocol.date"/></th>
                    <th><IntlMessage id = "protocol.doctor"/></th>
                    <th><IntlMessage id = "protocol.case"/></th>
                    <th><IntlMessage id = "protocol.protocol"/></th>
                    <th><IntlMessage id = "protocol.blade"/></th>
                    <th><IntlMessage id = "protocol.sent"/></th>
                    <th><IntlMessage id = "protocol.recognized"/></th>
                    <th><IntlMessage id = "protocol.chanting"/></th>
                    <th><IntlMessage id = "protocol.flushed"/></th>
                    <th><IntlMessage id = "protocol.finished"/></th>
                  </tr>
                </thead>
                <tbody>
                  {props.ventanaList.map((ventana, i) => {
                    return (
                      <tr key={ventana.id} onClick={()=> onSelectItems(ventana)} className={selectItems.findIndex(x => x.lamina == ventana.lamina) > -1 ? 'active-disabled' : ''}>
                        <td>{ventana.data}</td>
                        <td>{ventana.medico}</td>
                        <td>{ventana.caso}</td>
                        <td>{ventana.protocolo}</td>
                        <td>{ventana.lamina}</td>
                        <td>{getStatus(ventana.enviada)}</td>
                        <td>{getStatus(ventana.reconhecida)}</td>
                        <td>{getStatus(ventana.corando)}</td>
                        <td>{getStatus(ventana.corada)}</td>
                        <td>{getStatus(ventana.finalizada)}</td>
               
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
						<Button
						  disabled={props.ventanaList.length === 0}
						  className='protocol-ventana send'
              color="primary"
              onClick={() => props.sendVentana()}
            >
              <IntlMessage id = "dashboards.examDetail.message.submit"/>
            </Button>
          </TabPane>
        </TabContent>
      </div>
    )
  );
};

export default ProtocoloPage;



// WEBPACK FOOTER //
// ./src/app/common/protocolo/protocolo.page.js